import axios from 'axios'
import { useStore } from '@/stores/index.js'
function generateNonce(length = 13) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}


export function createAxiosInstance(options = {}) {


  const {
    baseURL = import.meta.env.VITE_APP_API_BASE_URL,
    timeout = 10000,
    getAuth,
    showLoading,
    hideLoading,
    showError,
    handle403,
  } = options;

  const instance = axios.create({
    baseURL,
    timeout,
    headers: { "Content-Type": "application/json" },
  });
  /**
   * 请求拦截
   */
  instance.interceptors.request.use(
    (config) => {
      try {
        showLoading?.()

      const store = useStore()
      // 是否是开发环境
      const isDev = import.meta.env.DEV

      //所有请求都带
      const commonParams = {
        nonce: generateNonce(),
        timestamp: Date.now(),
      }

      if (isDev) {
        //只有“需要登录态”的请求才带
        if (!config.noAuth && store.params.sign && store.params.uid) {
          commonParams.sign = store.params.sign
          commonParams.userid = store.params.uid
        }
      }



       

        // 获取基础参数（比如 P_PARAMS）
        const baseParams = getAuth ? getAuth() : {}


        if (config.method === 'post') {
          config.data = {
            ...baseParams,
            ...commonParams,
            ...(config.data || {})
          }
        }

        return config

      } catch (error) {
        hideLoading?.() // 防止卡死
        return Promise.reject(error)
      }
    },
    error => {
      hideLoading?.()
      return Promise.reject(error)
    }
  )

  /**
   * 响应拦截
   */
  instance.interceptors.response.use(
    (response) => {
      hideLoading && hideLoading()
      console.log(response.data);
      const res = response.data


      if (res.state === "200") {
        return res
      } else if (res.state === "403") {
        handle403 && handle403(res.msg || 'Login expired or no permission')
        return Promise.reject(res)
      }
      else if (res.state === "404") {
        showError && showError(`${response.request.responseURL} 404 Not Found`)
        return Promise.reject(res)
      }
      else if (res.state === "500") {
        handle403 && handle403(res.msg)
        return Promise.reject(res)
      }
      else {
        handle403 && handle403(res.msg)
        return Promise.reject(res)
      }
    },
    (error) => {
      hideLoading && hideLoading()

      // 网络错误 / HTTP 错误
      if (error.response) {


        const fullUrl = error.response?.request?.responseURL || ''
        const path = fullUrl ? new URL(fullUrl).pathname : ''
        const status = error.response.status




        if (status === 403) {
          handle403 && handle403('Login expired or no permission')
        }
        else if (status === 404) {
          showError && showError(`${path} 404 Not Found`)
        }
        else if (status === 500) {
          showError && showError(`${path} 500 Internal Server Error`)
        }
        else {
          showError && showError(`${path} RequestError-(${status})`)
        }
      } else {
        showError && showError(`Network Error Please try again later`)
      }

      return Promise.reject(error)
    }
  )

  return instance
}
